export class DetailPlanModel {
  Id: string;
  Nome: string;
  Descricao: string;
  EstabelecimentoId: string;
  EstabelecimentoNome: string;
  ValorTotal: number;
  Status: number;
  Detalhes: Array<PlanDetailModel>;

  constructor() {
    this.ValorTotal = 0;
  }
}

export class PlanDetailModel {
  ProdutoId: string;
  ProdutoNome: string;
  TipoPeriodicidade: number;
  Ciclos: number;
  DatasValoresPeriodicidadeManual: Array<DateValuePlan>;
}

export class DateValuePlan {
  Data: Date;
  Valor: Number;
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/models/plan-detail.model.ts